/**
 * NEOGRIPX Studio — página dedicada de pantalla completa
 * ------------------------------------------------------------
 * Vive en /pages/neogripx-studio (sections/neogripx-studio.liquid). Ya NO es
 * un modal: arranca automáticamente al cargar la página y "salir" navega a
 * /pages/personaliza-tu-kit en vez de cerrar un overlay.
 *
 * La generación de conceptos llama de verdad a FLUX.2 Pro a través de
 * window.NXStudioApi (ver assets/studio-api.js — ahí vive el mapeo de
 * campos y las rutas reales, este archivo no conoce esos detalles). Esa
 * parte no ha cambiado respecto al modal — solo el envoltorio de página.
 *
 * Sigue sin tocar: checkout, depósito, pago. El CTA final solo prepara un
 * mensaje de WhatsApp, como en el paso anterior.
 */
(function () {
  'use strict';

  var body = document.getElementById('nxStudioBody');
  if (!body) return; // esta página no tiene la sección -> no hacer nada
  if (!window.NXStudioApi) {
    console.error('NXStudioApi no está disponible — revisa que studio-api.js se cargue antes que studio.js.');
    return;
  }

  var LOADING_MESSAGES = [
    'Analizando tu bicicleta…',
    'Preparando la dirección gráfica…',
    'Creando conceptos NEOGRIPX…'
  ];

  var MAX_PHOTO_BYTES = 10 * 1024 * 1024; // 10 MB
  var ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  var MAX_ROUNDS_UI = 2; // solo para ocultar el botón de "otras propuestas" — el límite real lo aplica el backend
  var WHATSAPP_NUMBER = '34623768114'; // mismo número usado en cart-main.liquid / product-main.liquid

  var POLL_INTERVAL_MS = 2000;
  var GENERATION_TIMEOUT_MS = 90000;
  var SLOW_START_NOTE_MS = 10000; // si crear la sesión tarda más de esto, avisamos que es normal (backend "dormido")

  // ---------------------------------------------------------------------
  // Estado
  // ---------------------------------------------------------------------
  var state = null;
  var pendingTimeouts = [];
  var pollAbortToken = 0; // se incrementa para invalidar un poll en curso si el cliente sale de la página

  function freshState() {
    return {
      step: 1,
      bike: { brand: '', model: '', year: '', photoFile: null, photoDataUrl: null },
      style: { choice: '', otherText: '' },
      customization: { colors: [], reference: '', intensity: '', musts: '' },
      sessionId: null,
      round: 0,
      concepts: [],
      chosenConcept: null,
      generating: false
    };
  }

  // ---------------------------------------------------------------------
  // Helpers DOM
  // ---------------------------------------------------------------------
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function clearTimeouts() {
    pendingTimeouts.forEach(function (id) { clearTimeout(id); });
    pendingTimeouts = [];
  }
  function later(fn, ms) {
    var id = setTimeout(fn, ms);
    pendingTimeouts.push(id);
    return id;
  }

  // Elementos
  var exitBtn = document.getElementById('nxExitBtn');
  var exitConfirm = document.getElementById('nxExitConfirm');
  var exitConfirmStayBtn = document.getElementById('nxExitConfirmStay');
  var exitConfirmLeaveBtn = document.getElementById('nxExitConfirmLeave');
  var progressSteps = qsa('.nx-studio-progress-step');
  var backBtn = document.getElementById('nxBackBtn');
  var nextBtn = document.getElementById('nxNextBtn');

  var brandInput = document.getElementById('nxBrand');
  var modelInput = document.getElementById('nxModel');
  var yearInput = document.getElementById('nxYear');
  var photoInput = document.getElementById('nxPhotoInput');
  var photoPreview = document.getElementById('nxPhotoPreview');
  var photoPreviewImg = document.getElementById('nxPhotoPreviewImg');
  var photoRemoveBtn = document.getElementById('nxPhotoRemoveBtn');
  var photoStatus = document.getElementById('nxPhotoStatus');
  var step1Error = document.getElementById('nxStep1Error');

  var styleGrid = document.getElementById('nxStyleGrid');
  var styleOtherWrap = document.getElementById('nxStyleOtherWrap');
  var styleOtherInput = document.getElementById('nxStyleOther');
  var step2Error = document.getElementById('nxStep2Error');

  var colorGrid = document.getElementById('nxColorGrid');
  var colorHint = document.getElementById('nxColorHint');
  var referenceInput = document.getElementById('nxReference');
  var intensityRow = document.getElementById('nxIntensityRow');
  var mustsInput = document.getElementById('nxMusts');
  var step3Error = document.getElementById('nxStep3Error');

  var loadingBlock = document.getElementById('nxLoading');
  var loadingMsg = document.getElementById('nxLoadingMsg');
  var loadingNote = document.getElementById('nxLoadingNote');
  var checkAgainBtn = document.getElementById('nxCheckAgainBtn');
  var generationErrorBlock = document.getElementById('nxGenerationError');
  var generationErrorMsg = document.getElementById('nxGenerationErrorMsg');
  var generationRetryBtn = document.getElementById('nxGenerationRetryBtn');
  var resultsBlock = document.getElementById('nxResults');
  var conceptsGrid = document.getElementById('nxConceptsGrid');
  var regenBtn = document.getElementById('nxRegenBtn');
  var regenLimit = document.getElementById('nxRegenLimit');

  var summaryConcept = document.getElementById('nxSummaryConcept');
  var summaryList = document.getElementById('nxSummaryList');
  var briefingList = document.getElementById('nxBriefingList');
  var finalCtaWrap = document.getElementById('nxFinalCtaWrap');
  var requestBtn = document.getElementById('nxRequestBtn');
  var finalConfirm = document.getElementById('nxFinalConfirm');
  var whatsappBtn = document.getElementById('nxWhatsappBtn');

  // ---------------------------------------------------------------------
  // Arranque de página + salida (sustituye a abrir/cerrar modal)
  // ---------------------------------------------------------------------
  var intentionalExit = false; // evita que beforeunload vuelva a preguntar tras confirmar "Salir" nosotros mismos

  function initPage() {
    state = freshState();
    resetFormUI();
    goToStep(1);
    later(function () { if (brandInput) brandInput.focus(); }, 300);
  }

  // Hay "progreso" si el cliente ya ha metido algún dato — se usa para
  // decidir si hace falta confirmar antes de salir (nunca perder progreso
  // sin avisar).
  function hasProgress() {
    return !!(
      state.bike.brand ||
      state.bike.model ||
      state.bike.photoFile ||
      state.style.choice ||
      state.customization.colors.length ||
      state.customization.reference ||
      state.customization.intensity ||
      state.customization.musts ||
      state.sessionId
    );
  }

  function leaveStudio() {
    intentionalExit = true;
    clearTimeouts();
    pollAbortToken++; // invalida cualquier ciclo de polling en curso
    window.location.href = window.NX_STUDIO_EXIT_URL || '/pages/personaliza-tu-kit';
  }

  if (exitBtn) {
    exitBtn.addEventListener('click', function () {
      if (hasProgress()) {
        exitConfirm.hidden = false;
      } else {
        leaveStudio();
      }
    });
  }
  if (exitConfirmStayBtn) {
    exitConfirmStayBtn.addEventListener('click', function () {
      exitConfirm.hidden = true;
    });
  }
  if (exitConfirmLeaveBtn) {
    exitConfirmLeaveBtn.addEventListener('click', leaveStudio);
  }

  // Cierre de pestaña / recarga / navegación fuera de la página con
  // progreso sin guardar: aviso nativo del navegador (no se puede
  // personalizar el texto, pero sí evitar que salte cuando la salida ya
  // fue confirmada por nuestro propio diálogo).
  window.addEventListener('beforeunload', function (e) {
    if (intentionalExit) return;
    if (hasProgress()) {
      e.preventDefault();
      e.returnValue = '';
    }
  });

  function resetFormUI() {
    if (brandInput) brandInput.value = '';
    if (modelInput) modelInput.value = '';
    if (yearInput) yearInput.value = '';
    if (photoInput) photoInput.value = '';
    if (photoPreview) photoPreview.hidden = true;
    if (photoStatus) photoStatus.textContent = '';
    setError(step1Error, '');

    qsa('.nx-studio-style-opt', styleGrid).forEach(function (b) { b.classList.remove('is-selected'); });
    if (styleOtherWrap) styleOtherWrap.hidden = true;
    if (styleOtherInput) styleOtherInput.value = '';
    setError(step2Error, '');

    qsa('.nx-studio-color-chip', colorGrid).forEach(function (b) {
      b.classList.remove('is-selected');
      b.classList.remove('is-disabled');
    });
    if (colorHint) colorHint.textContent = '0/3 seleccionados';
    if (referenceInput) referenceInput.value = '';
    qsa('.nx-studio-intensity-opt', intensityRow).forEach(function (b) { b.classList.remove('is-selected'); });
    if (mustsInput) mustsInput.value = '';
    setError(step3Error, '');

    if (conceptsGrid) conceptsGrid.innerHTML = '';
    if (regenBtn) { regenBtn.hidden = false; regenBtn.disabled = false; }
    if (regenLimit) regenLimit.hidden = true;
    hideGenerationError();
    hideLoadingExtras();

    if (finalCtaWrap) finalCtaWrap.hidden = false;
    if (finalConfirm) finalConfirm.hidden = true;
  }

  function setError(el, msg) {
    if (!el) return;
    el.textContent = msg || '';
    el.style.display = msg ? 'block' : 'none';
  }

  // ---------------------------------------------------------------------
  // Navegación entre pasos
  // ---------------------------------------------------------------------
  var STEP_LABELS = { 1: 'Siguiente →', 2: 'Siguiente →', 3: 'Generar mis propuestas' };

  function goToStep(n) {
    state.step = n;

    qsa('.nx-studio-step', body).forEach(function (sec) {
      sec.hidden = Number(sec.getAttribute('data-nx-step')) !== n;
    });

    progressSteps.forEach(function (el) {
      var stepNum = Number(el.getAttribute('data-step'));
      el.classList.toggle('is-active', stepNum === n);
      el.classList.toggle('is-done', stepNum < n);
    });

    backBtn.hidden = n === 1;
    backBtn.disabled = !!state.generating;

    if (n === 4 || n === 5) {
      nextBtn.hidden = true;
    } else {
      nextBtn.hidden = false;
      nextBtn.textContent = STEP_LABELS[n] || 'Siguiente →';
    }

    if (body) body.scrollTop = 0;
  }

  backBtn.addEventListener('click', function () {
    if (state.generating) return;
    if (state.step === 4) {
      // Volver a editar el brief/la foto invalida la sesión actual (ya no
      // coincidiría con los nuevos datos) — se creará una nueva sesión en
      // el próximo intento de generación.
      pollAbortToken++;
      state.sessionId = null;
      state.round = 0;
      state.concepts = [];
    }
    if (state.step > 1) goToStep(state.step - 1);
  });

  nextBtn.addEventListener('click', function () {
    if (state.step === 1) {
      if (validateStep1()) goToStep(2);
    } else if (state.step === 2) {
      if (validateStep2()) goToStep(3);
    } else if (state.step === 3) {
      if (validateStep3()) {
        goToStep(4);
        runGeneration();
      }
    }
  });

  // ---------------------------------------------------------------------
  // PASO 1 — Tu bicicleta (foto OBLIGATORIA en V1)
  // ---------------------------------------------------------------------
  function setPhotoStatus(msg, isError) {
    if (!photoStatus) return;
    photoStatus.textContent = msg || '';
    photoStatus.classList.toggle('is-error', !!isError);
  }

  function showPhotoPreview(dataUrl) {
    if (!photoPreview || !photoPreviewImg) return;
    photoPreviewImg.src = dataUrl;
    photoPreview.hidden = false;
  }

  function handlePhotoFile(file) {
    if (!file) return;
    if (ALLOWED_PHOTO_TYPES.indexOf(file.type) === -1) {
      setPhotoStatus('Formato no admitido. Usa JPG, PNG o WEBP.', true);
      return;
    }
    if (file.size > MAX_PHOTO_BYTES) {
      setPhotoStatus('El archivo pesa demasiado (máx. 10 MB).', true);
      return;
    }
    state.bike.photoFile = file;

    var reader = new FileReader();
    reader.onload = function (e) {
      state.bike.photoDataUrl = e.target.result;
      showPhotoPreview(e.target.result);
      setPhotoStatus('Foto lista.', false);
      setError(step1Error, '');
    };
    reader.onerror = function () {
      setPhotoStatus('No se pudo leer la imagen, inténtalo de nuevo.', true);
      state.bike.photoFile = null;
    };
    reader.readAsDataURL(file);
  }

  if (photoInput) {
    photoInput.addEventListener('change', function (e) {
      handlePhotoFile(e.target.files && e.target.files[0]);
    });
  }
  if (photoRemoveBtn) {
    photoRemoveBtn.addEventListener('click', function () {
      state.bike.photoFile = null;
      state.bike.photoDataUrl = null;
      if (photoInput) photoInput.value = '';
      if (photoPreview) photoPreview.hidden = true;
      setPhotoStatus('', false);
    });
  }

  function validateStep1() {
    var brand = brandInput.value.trim();
    var model = modelInput.value.trim();
    state.bike.brand = brand;
    state.bike.model = model;
    state.bike.year = yearInput.value.trim();

    if (!brand || !model) {
      setError(step1Error, 'Indica al menos la marca y el modelo de tu bici.');
      return false;
    }
    if (!state.bike.photoFile) {
      setError(step1Error, 'Sube una foto de tu bicicleta para poder generar tus propuestas.');
      return false;
    }
    setError(step1Error, '');
    return true;
  }

  // ---------------------------------------------------------------------
  // PASO 2 — Estilo
  // ---------------------------------------------------------------------
  if (styleGrid) {
    qsa('.nx-studio-style-opt', styleGrid).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.nx-studio-style-opt', styleGrid).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.style.choice = btn.getAttribute('data-style');
        var isOther = state.style.choice === 'Otro';
        styleOtherWrap.hidden = !isOther;
        if (!isOther) {
          state.style.otherText = '';
          styleOtherInput.value = '';
        }
        setError(step2Error, '');
      });
    });
  }
  if (styleOtherInput) {
    styleOtherInput.addEventListener('input', function () {
      state.style.otherText = styleOtherInput.value;
    });
  }

  function validateStep2() {
    if (!state.style.choice) {
      setError(step2Error, 'Elige un estilo para continuar.');
      return false;
    }
    if (state.style.choice === 'Otro' && !state.style.otherText.trim()) {
      setError(step2Error, 'Cuéntanos brevemente qué estilo buscas.');
      return false;
    }
    setError(step2Error, '');
    return true;
  }

  // ---------------------------------------------------------------------
  // PASO 3 — Personalización
  // ---------------------------------------------------------------------
  function updateColorHint() {
    colorHint.textContent = state.customization.colors.length + '/3 seleccionados';
  }

  if (colorGrid) {
    qsa('.nx-studio-color-chip', colorGrid).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var color = chip.getAttribute('data-color');
        var idx = state.customization.colors.indexOf(color);

        if (idx > -1) {
          state.customization.colors.splice(idx, 1);
          chip.classList.remove('is-selected');
        } else {
          if (state.customization.colors.length >= 3) return;
          state.customization.colors.push(color);
          chip.classList.add('is-selected');
        }

        var atLimit = state.customization.colors.length >= 3;
        qsa('.nx-studio-color-chip', colorGrid).forEach(function (b) {
          if (!b.classList.contains('is-selected')) {
            b.classList.toggle('is-disabled', atLimit);
          }
        });

        updateColorHint();
        setError(step3Error, '');
      });
    });
  }

  if (intensityRow) {
    qsa('.nx-studio-intensity-opt', intensityRow).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.nx-studio-intensity-opt', intensityRow).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.customization.intensity = btn.getAttribute('data-intensity');
        setError(step3Error, '');
      });
    });
  }

  function validateStep3() {
    state.customization.reference = referenceInput.value.trim();
    state.customization.musts = mustsInput.value.trim();

    if (state.customization.colors.length === 0) {
      setError(step3Error, 'Elige al menos un color.');
      return false;
    }
    if (!state.customization.intensity) {
      setError(step3Error, 'Elige el nivel de impacto visual.');
      return false;
    }
    setError(step3Error, '');
    return true;
  }

  // ---------------------------------------------------------------------
  // PASO 4 — Generación real (sesión -> ronda -> polling)
  // ---------------------------------------------------------------------
  function hideLoadingExtras() {
    if (loadingNote) { loadingNote.hidden = true; loadingNote.textContent = ''; }
    if (checkAgainBtn) checkAgainBtn.hidden = true;
  }

  function hideGenerationError() {
    if (generationErrorBlock) generationErrorBlock.hidden = true;
  }

  function showGenerationError(message) {
    loadingBlock.hidden = true;
    resultsBlock.hidden = true;
    hideLoadingExtras();
    generationErrorMsg.textContent = message;
    generationErrorBlock.hidden = false;
  }

  function setLoadingMessage(msg) {
    if (loadingMsg) loadingMsg.textContent = msg;
  }

  var manualCheckAgain = null;

  if (checkAgainBtn) {
    checkAgainBtn.addEventListener('click', function () {
      if (manualCheckAgain) manualCheckAgain();
    });
  }
  if (generationRetryBtn) {
    generationRetryBtn.addEventListener('click', function () {
      hideGenerationError();
      runGeneration();
    });
  }
  if (regenBtn) {
    regenBtn.addEventListener('click', function () {
      if (state.round >= MAX_ROUNDS_UI) return;
      runGeneration();
    });
  }

  function setGeneratingUI(isGenerating) {
    state.generating = isGenerating;
    backBtn.disabled = isGenerating;
    if (regenBtn) regenBtn.disabled = isGenerating;
  }

  // Orquesta todo: crea sesión si hace falta -> pide una ronda -> hace
  // polling hasta ready/failed/timeout. Se usa tanto para la 1ª ronda
  // ("Generar mis propuestas") como para la 2ª ("Generar otras propuestas") —
  // el backend decide qué ronda corresponde, aquí nunca se cuenta a mano.
  function runGeneration() {
    var myToken = ++pollAbortToken;
    hideGenerationError();
    hideLoadingExtras();
    resultsBlock.hidden = true;
    loadingBlock.hidden = false;
    setLoadingMessage(LOADING_MESSAGES[0]);
    setGeneratingUI(true);

    var slowStartTimer = later(function () {
      if (myToken !== pollAbortToken) return;
      if (loadingNote) {
        loadingNote.hidden = false;
        loadingNote.textContent = 'Esto puede tardar un poco más de lo normal la primera vez.';
      }
    }, SLOW_START_NOTE_MS);

    var sessionPromise = state.sessionId
      ? Promise.resolve(state.sessionId)
      : NXStudioApi.createSession(state).then(function (id) {
          state.sessionId = id;
          return id;
        });

    sessionPromise
      .then(function (sessionId) {
        return NXStudioApi.generateRound(sessionId);
      })
      .then(function (genResp) {
        clearTimeout(slowStartTimer);
        if (myToken !== pollAbortToken) return; // el cliente salió de la página mientras tanto
        hideLoadingExtras();
        state.round = genResp.round;
        pollUntilDone(state.sessionId, state.round, myToken);
      })
      .catch(function (err) {
        clearTimeout(slowStartTimer);
        if (myToken !== pollAbortToken) return;
        console.error(err);
        setGeneratingUI(false);
        showGenerationError(NXStudioApi.describeError(err));
      });
  }

  function pollUntilDone(sessionId, round, myToken) {
    var startedAt = Date.now();
    var timedOut = false;

    function tick() {
      if (myToken !== pollAbortToken) return; // abortado (el cliente salió de la página)

      var elapsed = Date.now() - startedAt;

      if (elapsed >= GENERATION_TIMEOUT_MS && !timedOut) {
        timedOut = true;
        setLoadingMessage('Esto está tardando más de lo esperado.');
        if (loadingNote) {
          loadingNote.hidden = false;
          loadingNote.textContent = 'Tu diseño se sigue procesando. Puedes comprobarlo de nuevo cuando quieras.';
        }
        if (checkAgainBtn) checkAgainBtn.hidden = false;
        manualCheckAgain = function () {
          if (checkAgainBtn) checkAgainBtn.hidden = true;
          checkOnce();
        };
        return; // deja de sondear solo; el botón manual retoma
      }

      var msgIndex = Math.min(Math.floor(elapsed / 8000), LOADING_MESSAGES.length - 1);
      if (!timedOut) setLoadingMessage(LOADING_MESSAGES[msgIndex]);

      checkOnce(function () {
        later(tick, POLL_INTERVAL_MS);
      });
    }

    function checkOnce(onStillProcessing) {
      NXStudioApi.pollRound(sessionId, round)
        .then(function (data) {
          if (myToken !== pollAbortToken) return;

          if (data.status === 'ready') {
            setGeneratingUI(false);
            finishGeneration(data.concepts);
            return;
          }
          if (data.status === 'failed') {
            setGeneratingUI(false);
            showGenerationError('No hemos podido generar las propuestas esta vez. Puedes intentarlo de nuevo.');
            return;
          }
          // "processing": sigue esperando
          if (onStillProcessing) onStillProcessing();
        })
        .catch(function (err) {
          if (myToken !== pollAbortToken) return;
          console.error(err);
          setGeneratingUI(false);
          showGenerationError(NXStudioApi.describeError(err));
        });
    }

    tick();
  }

  function finishGeneration(concepts) {
    state.concepts = concepts;
    renderConcepts(concepts);

    loadingBlock.hidden = true;
    hideLoadingExtras();
    resultsBlock.hidden = false;

    var canRegen = state.round < MAX_ROUNDS_UI;
    regenBtn.hidden = !canRegen;
    regenLimit.hidden = canRegen;
  }

  function renderConcepts(concepts) {
    conceptsGrid.innerHTML = concepts
      .map(function (c) {
        return (
          '<div class="nx-studio-concept-card">' +
          '<div class="nx-studio-concept-visual">' +
          '<img src="data:' + c.mimeType + ';base64,' + c.imageBase64 + '" alt="Concepto ' + c.id + '" loading="lazy">' +
          '</div>' +
          '<h3>Concepto ' + c.id + '</h3>' +
          '<button type="button" class="nx-studio-concept-choose" data-concept-id="' + c.id + '">Elegir este diseño</button>' +
          '</div>'
        );
      })
      .join('');
  }

  if (conceptsGrid) {
    conceptsGrid.addEventListener('click', function (e) {
      var btn = e.target.closest('.nx-studio-concept-choose');
      if (!btn) return;
      var id = btn.getAttribute('data-concept-id');
      var chosen = state.concepts.filter(function (c) { return c.id === id; })[0];
      if (!chosen) return;
      state.chosenConcept = chosen;
      renderStep5();
      goToStep(5);
    });
  }

  // ---------------------------------------------------------------------
  // PASO 5 — Resumen + briefing (generado en JS, sin IA — sin cambios)
  // ---------------------------------------------------------------------
  function joinColors(colors) {
    if (colors.length === 1) return colors[0];
    if (colors.length === 2) return colors[0] + ' y ' + colors[1];
    return colors.slice(0, -1).join(', ') + ' y ' + colors[colors.length - 1];
  }

  function styleLabel() {
    return state.style.choice === 'Otro' ? state.style.otherText : state.style.choice;
  }

  // Máximo 5 puntos, uno por cada dato conceptual recogido. Nunca usa IA.
  function buildBriefing() {
    var bullets = [];
    var s = styleLabel();

    if (s) bullets.push('Estética ' + s.toLowerCase() + '.');
    if (state.customization.colors.length) bullets.push(joinColors(state.customization.colors) + '.');
    if (state.customization.reference) bullets.push('Inspiración: ' + state.customization.reference + '.');
    if (state.customization.intensity) {
      var intensityMap = {
        Discreto: 'Impacto visual discreto.',
        Equilibrado: 'Impacto visual equilibrado.',
        'Muy llamativo': 'Alto impacto visual.'
      };
      bullets.push(intensityMap[state.customization.intensity] || ('Intensidad: ' + state.customization.intensity + '.'));
    }
    if (state.customization.musts) bullets.push('Incluir ' + state.customization.musts + '.');

    return bullets.slice(0, 5); // nunca más de 5 puntos
  }

  function renderStep5() {
    summaryConcept.innerHTML =
      '<div class="nx-studio-summary-visual"><img src="data:' + state.chosenConcept.mimeType + ';base64,' + state.chosenConcept.imageBase64 + '" alt="Concepto elegido"></div>' +
      '<div><strong>Concepto ' + state.chosenConcept.id + '</strong></div>';

    var bikeLine = [state.bike.brand, state.bike.model].filter(Boolean).join(' ') +
      (state.bike.year ? ' (' + state.bike.year + ')' : '');

    var rows = [
      ['Bicicleta', bikeLine || '—'],
      ['Foto', 'Subida por el cliente'],
      ['Estilo', styleLabel() || '—'],
      ['Colores', state.customization.colors.join(', ') || '—'],
      ['Referencia', state.customization.reference || '—'],
      ['Intensidad', state.customization.intensity || '—'],
      ['Elementos imprescindibles', state.customization.musts || '—']
    ];

    summaryList.innerHTML = rows
      .map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; })
      .join('');

    var briefing = buildBriefing();
    briefingList.innerHTML = briefing.map(function (b) { return '<li>' + b + '</li>'; }).join('');

    finalCtaWrap.hidden = false;
    finalConfirm.hidden = true;
  }

  function buildWhatsappMessage() {
    var briefing = buildBriefing();
    var bikeLine = [state.bike.brand, state.bike.model].filter(Boolean).join(' ') +
      (state.bike.year ? ' (' + state.bike.year + ')' : '');

    var lines = [
      'Hola! Quiero solicitar mi diseño personalizado de NEOGRIPX Studio:',
      '',
      'Bici: ' + (bikeLine || '-'),
      'Foto: sí, la adjunto en el chat',
      'Estilo: ' + (styleLabel() || '-'),
      'Colores: ' + (state.customization.colors.join(', ') || '-'),
      'Referencia: ' + (state.customization.reference || '-'),
      'Intensidad: ' + (state.customization.intensity || '-'),
      'Elementos imprescindibles: ' + (state.customization.musts || '-'),
      'Concepto elegido: ' + (state.chosenConcept ? 'Concepto ' + state.chosenConcept.id : '-'),
      '',
      'Briefing:'
    ];
    briefing.forEach(function (b) { lines.push('- ' + b); });

    return lines.join('\n');
  }

  if (requestBtn) {
    requestBtn.addEventListener('click', function () {
      var message = buildWhatsappMessage();
      whatsappBtn.href = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(message);
      finalCtaWrap.hidden = true;
      finalConfirm.hidden = false;
    });
  }

  // Página dedicada: el wizard arranca solo, no espera a que se pulse un
  // botón "abrir" (ese botón ahora vive en /pages/personaliza-tu-kit y es
  // un simple enlace a esta página).
  initPage();
})();
